<template>
  <div class="line-separator">
    <div class="sort-ads">
      <span>{{ $t('sort.title.text') }}:</span>
      <el-button
        :class="{active: sort === 'newest'}"
        @click="sortBy('newest')"
      >
        {{ $t('sort.newest.text') }}
      </el-button>
      <el-button
        :class="{active: sort === 'price_low'}"
        @click="sortBy('price_low')"
      >
        {{ $t('sort.lowest-price.text') }}
      </el-button>
      <el-button
        :class="{active: sort === 'price_high'}"
        @click="sortBy('price_high')"
      >
        {{ $t('sort.highest-price.text') }}
      </el-button>
      <el-button
        icon="icon-list-ads"
        :class="{active: adViewType === 'list'}"
        @click="visibleAdList('list')"
      />
      <el-button
        icon="icon-grid-ads"
        :class="{active: adViewType === 'grid'}"
        @click="visibleAdList('grid')"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mutations from '../../store/mutationlist';
import filterMutations from '../../store/filters/filters.mutationlist';

export default {
  data() {
    return {
      visible: '',
    };
  },
  computed: {
    ...mapState({
      adViewType: state => state.ad_view_type,
      sort: state => state.filters.sort,
    }),
  },
  methods: {
    visibleAdList(paypload) {
      this.$store.commit(mutations.SET_DEEP, { key: 'ad_view_type', value: paypload });
    },
    sortBy(type) {
      this.$store.commit(filterMutations.FILTER_SET, { key: 'sort', value: type });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Ads/SortAds.vue